import React, { useState, useEffect } from 'react';
import { BASE_URL } from './config';

const SelectAziende = ({ onSelectedData }) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // Stato per l'azienda selezionata

  useEffect(() => {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + sessionStorage.getItem('accessToken'));
    headers.append('Content-Type', 'application/json');

    fetch(BASE_URL + '/v1/user/aziende', {
      headers: headers
    })
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          setOptions(data);
          // Seleziona automaticamente il primo elemento dell'array
          if (data.length > 0) {
            setSelectedOption(data[0]);
            const firstOptionTipologia = data[0].tipologie.map(tipo => tipo.code).join(',');
            const selectedData = {
              id: data[0].idAzienda,
              tipologia: firstOptionTipologia
            };
            onSelectedData(selectedData);
          }
        } else {
          console.error('I dati ottenuti non sono un array:', data);
        }
      })
      .catch(error => console.error('Errore durante la chiamata API:', error));
  }, []);

  const handleSelectAzienda = (azienda) => {
    setSelectedOption(azienda);
    const selectedTipologia = azienda.tipologie.map(tipo => tipo.code).join(',');
    const selectedData = {
      id: azienda.idAzienda,
      tipologia: selectedTipologia
    };
    onSelectedData(selectedData);
  };

  return (
    <div>
      {selectedOption && (
        <div>
          <p>{selectedOption.nomeAzienda}</p>
          {/* Aggiungi qui un bottone o un altro elemento cliccabile per selezionare un'azienda */}
          
        </div>
      )}
      {/* Opzionalmente, puoi mostrare un elenco delle aziende per consentire all'utente di scegliere */}
      {/* <ul>
        {options.map(option => (
          <li key={option.idAzienda}>
            <button onClick={() => handleSelectAzienda(option)}>{option.nomeAzienda}</button>
          </li>
        ))}
      </ul> */}
    </div>
  );
};

export default SelectAziende;
